module.exports = __webpack_public_path__ + "img/book1.532b393.png";